import { Tooltip, Box, TooltipProps, useOutsideClick } from "@chakra-ui/react";
import React, { useRef, useState } from "react";

/**
 * The standard chakra tooltip is only intended for desktop use.
 * We wrap it here to make it mobile friendly.
 * https://github.com/chakra-ui/chakra-ui/issues/2691
 */
export function TooltipWithTouch({ children, ...props }: TooltipProps) {
  const [isLabelOpen, setIsLabelOpen] = useState(false);

  const ref = useRef<HTMLDivElement>(null);

  useOutsideClick({
    ref,
    handler: () => {
      setIsLabelOpen(false);
    },
  });

  return (
    <Tooltip isOpen={isLabelOpen} {...props}>
      <Box
        ref={ref}
        minW={0}
        maxW="full"
        // only actual mouse devices are intended to trigger on hover
        onPointerEnter={(event) => {
          if (event.pointerType === "mouse") {
            setIsLabelOpen(true);
          }
        }}
        onPointerLeave={(event) => {
          if (event.pointerType === "mouse") {
            setIsLabelOpen(false);
          }
        }}
        // all devices can toggle the tooltip on touch
        onClick={() => {
          setIsLabelOpen((isOpen) => !isOpen);
        }}
      >
        {children}
      </Box>
    </Tooltip>
  );
}
